export const DATA_NEWS = "tin-tuc";
export const DATA_NEWS_TRAINING = "tap-huan";
